import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-minecraft',
  templateUrl: './minecraft.component.html',
  styleUrls: ['./minecraft.component.scss'],
})
export class MinecraftComponent implements OnInit {
  modulesText = {
    text: 'Dopo una breve introduzione della piattaforma e delle sue funzionalità, il corso affronta le diverse applicazioni del programma attraverso esercizi individuali e di gruppo.',
  };

  constructor() {}

  ngOnInit(): void {}
}
